import axios from 'axios';

const createCouponApi = async (token, values, langIsoCode) => {
  try {
    const res = await axios.post('/Coupon/add', values, {
      headers: {
        lang: langIsoCode || 'ar',
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + token
      }
    });
    return res;
  } catch (error) {
    throw new Error(error);
  }
};

export default createCouponApi;
